import { update } from 'state/util';

export const UI_FLOW = {
  // unknown location of client, or nothing (default state)
  NONE: 0,
  SET: 1,
};


const initialState = {
  status: UI_FLOW.NONE,
  visible: false,
};

// user reducer, for registering, logging in, etc
export const annotationVisibilityReducer = (state = initialState, action) => {
  switch(action.type) {
    case "SET_ANNOTATION_VISIBILITY":
      return update(state, {
        status: UI_FLOW.SET,
        visible: action.payload.visible,
      });
    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/state/annotationVisibility/reducer.js